/*
 * Module for an item from the basicAdminList
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/basicAdminItemModal/basicAdminItemModalView",
], function (Marionette, Messenger, BasicAdminItemModalView) {
  var BasicAdminItemModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "basicAdminItem";
      this.region = options.region;
    },
    show: function (itemBundle) {
      //item bundle includes the itemModel and areaModel
      var itemModel = itemBundle.itemModel;
      var areaModel = itemBundle.areaModel;
      this.view = new BasicAdminItemModalView.basicAdminItemModalView({
        model: itemModel,
        nameAttribute: areaModel.get("nameAttribute"),
        descriptionAttribute: areaModel.get("descriptionAttribute"),
      });

      //handle bad save
      itemModel.on(
        "invalid",
        function (model, error) {
          //Clear errors first
          this.view.clearError();
          var nameAttribute = areaModel.get("nameAttribute");
          var descriptionAttribute = areaModel.get("descriptionAttribute");
          if (error[nameAttribute] != undefined) {
            this.view.showError("Name", error[nameAttribute]);
          }
          if (error[descriptionAttribute] != undefined) {
            this.view.showError("Description", error[descriptionAttribute]);
          }
        },
        this,
      );

      this.view.on(
        "done",
        function () {
          if (!itemModel.readOnly) {
            //keep old values in case we need to revert
            var name = itemModel.get(areaModel.get("nameAttribute"));
            if (areaModel.get("descriptionAttribute")) {
              var desc = itemModel.get(areaModel.get("descriptionAttribute"));
            }
            //get parameters from view
            itemModel.set(areaModel.get("nameAttribute"), this.view.getNameValue());
            if (areaModel.get("descriptionAttribute")) {
              itemModel.set(areaModel.get("descriptionAttribute"), this.view.getDescriptionValue());
            }
            //save model
            itemModel.saveModel({
              success: function () {
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                Messenger.showErrorFromResponse(response);
                //revert attributes
                itemModel.set(areaModel.get("nameAttribute"), name);
                if (areaModel.get("descriptionAttribute")) {
                  itemModel.set(areaModel.get("descriptionAttribute"), desc);
                }
                //close modal
                Messenger.vent.trigger("close:modal");
              },
            });
          } else {
            Messenger.vent.trigger("close:modal"); //just close a modal for read only items
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          //if item is new, delete it
          if (itemModel.isNew()) {
            itemModel.deleteModel();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return BasicAdminItemModalController;
});
